import styled from "styled-components";
import { defaultTheme } from "../../shared/constants";

export type RadioProps = {
  name: string;
  value: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
};

export const Radio = ({
  name,
  value,
  checked,
  disabled,
  onChange,
  label,
}: RadioProps) => {
  return (
    <RadioContainer>
      <RadioInput
        id={name}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <RadioLabel htmlFor={name}>{label}</RadioLabel>
    </RadioContainer>
  );
};

const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${defaultTheme.SPACING.XS};
`;

const RadioInput = styled.input`
  appearance: none;

  border-radius: 50%;
  width: 16px;
  height: 16px;

  border: 2px solid ${defaultTheme.COLORS.BLACK_GREY};
  transition: 0.2s all linear;
  margin: 0;
  position: relative;
  cursor: pointer;

  &:checked {
    border-color: ${defaultTheme.COLORS.BLACK_GREY};
  }

  &:checked::after {
    content: "";
    display: block;
    width: 8px;
    height: 8px;
    background-color: ${defaultTheme.COLORS.BLACK_GREY};
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  &:disabled:checked::after {
    background-color: ${defaultTheme.COLORS.DARK_GREY};
  }
`;

const RadioLabel = styled.label`
  font-family: ${defaultTheme.FONT.FAMILY.BODY};
  font-size: ${defaultTheme.FONT.SIZE.STANDARD};
  color: ${defaultTheme.COLORS.BLACK_GREY};
  font-weight: ${defaultTheme.FONT.WEIGHT.MEDIUM};
`;
